import injectTapEventPlugin from 'react-tap-event-plugin';
// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin();
import React from 'react'
import ReactDOM from 'react-dom'
import { browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'

import { initAuth } from './core/auth'
import configureStore from './core/store'
import Root from './views/root'
import './views/styles/style.css'


let store = configureStore()
const syncedHistory = syncHistoryWithStore(browserHistory, store);
const rootElement = document.getElementById('root');

function render(Root) {
  ReactDOM.render(
    <Root history={syncedHistory} store={store} />,
    rootElement
  )
}

initAuth(store.dispatch)
  .then(() => render(Root))
  .catch(error => console.error(error))


// WEBPACK FOOTER //
// ./src/index.js